<template>
  <div class="project-sidebar">
    <div>
      <button class="btn--subtile" @click="$emit('back')">&laquo; zurück</button>
      <h2 style="margin-top: 0"><blur-editable :content="$parent.projectTitle['.value']" @change="$emit('projectTitleChange', $event)"></blur-editable></h2>
      <blur-editable-enter :content="$parent.projectDescription['.value']" @change="$emit('projectDescriptionChange', $event)"></blur-editable-enter>
      <project-sidebar-map :items="$parent.projectPosts()"></project-sidebar-map>
    </div>
  </div>
</template>

<script>
import ProjectSidebarMap from '@/components/ProjectSidebarMap'
import BlurEditable from '@/components/BlurEditable'
import BlurEditableEnter from '@/components/BlurEditableEnter'

export default {
  name: 'ProjectSidebar',
  // props: ['item', 'id'],
  components: {
    ProjectSidebarMap,
    BlurEditable,
    BlurEditableEnter
  },
  data () {
    return {
      project: this.$parent.project
    }
  },
  methods: {
    test () {
      // console.log(this.$el.getBoundingClientRect().left)
      // console.log(this.$el.getBoundingClientRect().left)
      // console.log(this.$el.getBoundingClientRect().top)
    }
  }
}
</script>

<style lang="scss">
  .project-sidebar {
    width: 35%;
    height: 100vh;
    box-shadow: 0 2px 24px 0 rgba(38,50,56,0.15);
    @media screen and (min-width: 1200px) {
      width: 25%;
    }
    background: rgba($color-action,0.1);
    // background: rgba($color-action,0.11);
    padding: 30px 30px 50px;
    box-sizing: border-box;
    flex-shrink: 0;

    position: relative;

    h2 {
      color: $color-text;
    }

    .leaflet-container {
      background: #f3f3fb;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectSidebar.vue